import React, { Fragment } from 'react';
import ClosePositionModalContainer from 'modules/TradesPW3/Positions/components/ClosePositionModalContainer/ClosePositionModalContainer';
import ChangeThemeModalContainer from 'modules/TradingChart/components/TradingView/components/ChangeThemeModalContainer/ChangeThemeModalContainer';
import ChartSaveSettingsModalContainer from 'modules/TradingChart/components/TradingView/components/ChartSaveSettingsModalContainer/ChartSaveSettingsModalContainer';
import OptionChainModalContainer from 'modules/OptionChain/components/OptionChainModalContainer';
import OrderReviewModalContainer from 'modules/TradingChart/components/TradingView/components/OrderReviewModalContainer/OrderReviewModalContainer';
import ChartSyncProgressModalContainer from 'modules/TradingChart/components/TradingView/components/ChartSyncProgressModalContainer/ChartSyncProgressModalContainer';
import NotificationCenterContainer from 'modules/NotificationCenter/components/NotificationCenterContainer';
import ImportantLinksModal from 'modules/TradingChart/components/TradingView/components/ImportantLinksModal/ImportantLinksModal';
import TBTVideoModal from 'modules/TradingChart/components/TradingView/components/TBTVideoModal/TBTVideoModal';
import PriceAlertsModalContainer from 'modules/PriceAlerts/components/PriceAlertsModalContainer';
import PositionMtmExitAllModal from 'modules/TradingChart/components/TradingView/components/PositionsMtmExitAllModal/PositionsMtmExitAllModal';
import PriceAlertsNotification from 'modules/PriceAlerts/components/PriceAlertsNotification';
import ToastContainer from 'modules/ToastContainer';
import ReleaseNotesModalContainer from 'modules/ReleaseNotes/components/ReleaseNotesModalContainer';
import ChartSyncDisclaimerModal from 'modules/TradingChart/components/TradingView/components/ChartSyncDisclaimerModal/ChartSyncDisclaimerModal';
import ConvertPositionModalContainer from 'modules/TradesPW3/Positions/components/ConvertPositionModalContainer';

export const GlobalModals: React.FC = () => (
  <Fragment>
    <ClosePositionModalContainer />
    <ChangeThemeModalContainer />
    <ChartSaveSettingsModalContainer />
    <OptionChainModalContainer />
    <PriceAlertsModalContainer />
    <OrderReviewModalContainer />
    <ChartSyncProgressModalContainer />
    <NotificationCenterContainer />
    <ImportantLinksModal />
    <TBTVideoModal />
    <PositionMtmExitAllModal />
    <PriceAlertsNotification />
    <ToastContainer />
    <ReleaseNotesModalContainer />
    <ChartSyncDisclaimerModal />
    <ConvertPositionModalContainer />
  </Fragment>
);
